module.exports = __webpack_public_path__ + "img/img33.085506b2.png";